import { Component, Input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../ui/button/button.component';
import { RouterLink } from '@angular/router';
import { SafePipe } from '../../shared/pipes/safe/safe.pipe';

export interface IndustryBlockLogo {
  src: string;
  width: number;
  height: number;
  alt: string;
}

export interface IndustryBlockConfig {
  id: number;
  label?: string;
  title: string;
  text: string;
  buttonText: string;
  buttonLink: string;
  image: {
    src: string;
    alt: string;
  };
  logos: IndustryBlockLogo[];
  backgroundColor?: string;
}

@Component({
  selector: 'app-industry-block',
  imports: [
    CommonModule,
    TranslateModule,
    ButtonComponent,
    RouterLink,
    NgOptimizedImage,
    SafePipe
  ],
  templateUrl: './industry-block.component.html',
  styleUrl: './industry-block.component.scss'
})
export class IndustryBlockComponent {
  @Input() config: IndustryBlockConfig;

  get backgroundStyle(): { [key: string]: string } {
    return this.config?.backgroundColor
      ? { 'background-color': this.config.backgroundColor }
      : {};
  }
}
